import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import CardsComponent from '../cards/CardsComponents';
import Faqs from '../faqs/Faqs';

interface TradingHour {
  day: string;
  time: string;
}

interface Store {
  title: string;
  customHeading?: string;
  holidayNotice?: string[];
  address: string;
  phone: string;
  email: string;
  tradingHours: TradingHour[];
  mapUrl: string;
  appointmentOnly?: boolean;
}

interface AccordionComponentProps {
  title: string;
  stores?: Store[];
  displayFAQs?: boolean;
  questions?: any;
  isTop?: string | number;
  panelNumber: number;
  expanded: string | false;
  handleChange: (
    panel: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const AccordionComponent: React.FC<AccordionComponentProps> = ({
                                                                 title,
                                                                 stores = [],
                                                                 displayFAQs = false,
                                                                 questions = [],
                                                                 isTop = 0,
                                                                 panelNumber,
                                                                 expanded,
                                                                 handleChange,
                                                               }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        top: isTop,
      }}
    >
      <Accordion
        elevation={0}
        expanded={expanded === `panel${panelNumber}`}
        onChange={handleChange(`panel${panelNumber}`)}
        sx={{ width: '100%' }}
      >
        <AccordionSummary
          expandIcon={
            expanded === `panel${panelNumber}` ? (
              <RemoveCircleOutlineOutlinedIcon />
            ) : (
              <AddCircleOutlineOutlinedIcon />
            )
          }
          aria-controls={`panel${panelNumber}bh-content`}
          id={`panel${panelNumber}bh-header`}
          sx={{
            px: 0,
            borderBottom:
              expanded === `panel${panelNumber}` ? 'none' : '#000 solid 1px',
          }}
        >
          <Typography
            variant='h1'
            sx={{
              fontSize: '32px',
              fontWeight: '500',
              lineHeight: '28px',
              color: '#101828',
              mt: 1,
            }}
          >
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            borderBottom: '#000 1px solid',
            px: 0,
          }}
        >
          <AccordionDetails sx={{ width: '100%' }}>
            <Grid container spacing={4}>
              {displayFAQs ? (
                <Faqs questions={questions} />
              ) : (
                stores.map((store: Store, index: number) => (
                  <Grid
                    item
                    xs={12}
                    lg={4}
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'unset',
                      justifyContent: 'unset',
                      m: 0,
                    }}
                  >
                    <CardsComponent
                      title={store.title}
                      customHeading={store.customHeading}
                      holidayNotice={store.holidayNotice}
                      tradingHours={store.tradingHours}
                      phone={store.phone}
                      email={store.email}
                      address={store.address}
                      mapUrl={store.mapUrl}
                      appointmentOnly={store.appointmentOnly}
                    />
                  </Grid>
                ))
              )}
            </Grid>
          </AccordionDetails>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default AccordionComponent;